import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'

const THEME_STORAGE_KEY = 'oms-theme'
const THEME_OPTIONS = {
  LIGHT: 'light',
  DARK: 'dark',
}

const ThemeContext = createContext(null)

const getInitialTheme = () => {
  if (typeof window === 'undefined') {
    return THEME_OPTIONS.LIGHT
  }

  const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY)
  if (storedTheme === THEME_OPTIONS.DARK || storedTheme === THEME_OPTIONS.LIGHT) {
    return storedTheme
  }

  return THEME_OPTIONS.LIGHT
}

const applyThemeClass = (theme) => {
  if (typeof document === 'undefined') {
    return
  }

  const root = document.documentElement
  root.classList.toggle('dark', theme === THEME_OPTIONS.DARK)
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme)

  useEffect(() => {
    applyThemeClass(theme)
    window.localStorage.setItem(THEME_STORAGE_KEY, theme)
  }, [theme])

  const value = useMemo(() => {
    const isDark = theme === THEME_OPTIONS.DARK

    return {
      theme,
      isDark,
      setTheme,
      themeOptions: THEME_OPTIONS,
      toggleTheme: () => setTheme(isDark ? THEME_OPTIONS.LIGHT : THEME_OPTIONS.DARK),
    }
  }, [theme])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export function useTheme() {
  const context = useContext(ThemeContext)

  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider')
  }

  return context
}
